module.exports = __webpack_public_path__ + "static/img/11.1288ea3a.png";